import { Flex, Switch, Table, Tbody } from '@chakra-ui/react'
import type { OrganizationUnit } from 'BrokerTsLib/src/dtos'
import { getDealerTypeName } from 'BrokerTsLib/src/enums'

import { TableSection } from '@/components/Section/TableSection'
import { TableSectionRow } from '@/components/Section/TableSectionRow'

export const OrganizationMotivation = ({
  organization,
}: {
  organization?: OrganizationUnit
}) => (
  <TableSection
    sectionTitle={
      <Flex alignItems="center" justifyContent='space-between' gap={2}>
        Zařazení
        <Switch isChecked={organization?.ouMotivation?.motivationYesNo} isReadOnly />
      </Flex>
    }
    wide={true}
  >
    <Table variant={'simple'} fontSize={'md'} borderRadius={8}>
      <Tbody>
        <TableSectionRow title="Typ dealera">
          {getDealerTypeName(organization?.ouMotivation?.dealerType)}
        </TableSectionRow>
        <TableSectionRow title="Pobočka UCL">
          {organization?.ouMotivation?.branchUcl}
        </TableSectionRow>
        <TableSectionRow title="Obchodník">
          {organization?.ouMotivation?.trader}
        </TableSectionRow>
      </Tbody>
    </Table>
  </TableSection>
)
